import { get, post } from 'aws-amplify/api';
import { PRESCRIPTSURE } from '../constants/api-endpoints';
import { getSessionToken } from './service-config'; // Import the helper function
const apiNamePath = PRESCRIPTSURE.USER_API; // API endpoint from constants

const userApiService = {
  async updateOrganisationDetails(userName, updateAttributes, orgOwnerSub) {
    const sessionToken = await getSessionToken();

    const updateOrganisationOperation = post({
      apiName: apiNamePath,
      path: '/create_update_user',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          action_type: 'update',
          user_name: userName,
          ...updateAttributes,
          org_owner_sub: orgOwnerSub,
        },
      },
    });

    const updateOrganisationResult = (
      await updateOrganisationOperation.response
    ).body.json();

    return updateOrganisationResult;
  },

  async createOrganizationUser(userDetails, orgOwnerSub) {
    const sessionToken = await getSessionToken();

    const createOrganizationUserOperation = post({
      apiName: apiNamePath,
      path: '/create_update_user',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          action_type: 'create',
          org_owner_sub: orgOwnerSub,
          ...userDetails,
        },
      },
    });

    const createOrganizationUserResult = (
      await createOrganizationUserOperation.response
    ).body.json();

    return createOrganizationUserResult;
  },

  async deleteOrganizationUser(userName, orgOwnerSub) {
    const sessionToken = await getSessionToken();

    const createOrganizationUserOperation = post({
      apiName: apiNamePath,
      path: '/delete_disable_user',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          action_type: 'delete',
          user_name: userName,
          org_owner_sub: orgOwnerSub,
        },
      },
    });

    const createOrganizationUserResult = (
      await createOrganizationUserOperation.response
    ).body.json();

    return createOrganizationUserResult;
  },

  async updateStatusOfOrganizationUser(userName, isEnabled, orgOwnerSub) {
    const sessionToken = await getSessionToken();

    const updateStatusOfOrganizationUserOperation = post({
      apiName: apiNamePath,
      path: '/delete_disable_user',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          action_type: isEnabled ? 'disable' : 'enable',
          user_name: userName,
          org_owner_sub: orgOwnerSub,
        },
      },
    });

    const updateStatusOfOrganizationUserResult = (
      await updateStatusOfOrganizationUserOperation.response
    ).body.json();

    return updateStatusOfOrganizationUserResult;
  },

  async listOrganizationUsers({
    limit,
    searchTerm,
    pageNumber,
    organizationID,
  }) {
    const sessionToken = await getSessionToken();

    const listOrganizationUsersOperation = post({
      apiName: apiNamePath,
      path: '/list_users',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          limit: limit,
          search_term: searchTerm,
          page_number: pageNumber,
          organization_id: organizationID,
        },
      },
    });

    const listOrganizationUsersResult = (
      await listOrganizationUsersOperation.response
    ).body.json();

    return listOrganizationUsersResult;
  },

  async getUserRoleTypes() {
    // list_user_types is a public endpoint — send auth token when available
    // (authenticated users) and omit it when there's no session (signup page).
    let headers = {};
    try {
      const sessionToken = await getSessionToken();
      headers = { Authorization: `Bearer ${sessionToken}` };
    } catch {
      // No active session — proceed without auth header
    }
    const getUserRolesOperation = get({
      apiName: apiNamePath,
      path: '/list_user_types',
      options: {
        headers,
        queryParams: {},
      },
    });

    const getUserRolesResult = (
      await getUserRolesOperation.response
    ).body.json();

    return getUserRolesResult;
  },

  async uploadImage(formData) {
    const sessionToken = await getSessionToken();

    const uploadImageOperation = post({
      apiName: apiNamePath,
      path: '/image_upload',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: formData,
      },
    });

    const uploadImageResult = (await uploadImageOperation.response).body.json();

    return uploadImageResult;
  },

  async getOrgDetails() {
    const sessionToken = await getSessionToken();
    const operation = post({
      apiName: apiNamePath,
      path: '/get_org_admin_details',
      options: {
        headers: { Authorization: `Bearer ${sessionToken}` },
        body: {},
      },
    });
    return (await operation.response).body.json();
  },

  async sendPasswordChangeMail(name, email) {
    const sessionToken = await getSessionToken();

    const sendPasswordChangeMailOperation = post({
      apiName: apiNamePath,
      path: '/password_change',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          user_name: name,
          user_email: email,
        },
      },
    });

    const sendPasswordChangeMailResult = (
      await sendPasswordChangeMailOperation.response
    ).body.json();

    return sendPasswordChangeMailResult;
  },
};

export default userApiService;
